import {Box, HBox} from '@buncha/components/core/view';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Checkbox} from 'native-base';
import {H6Text} from '@buncha/components/core/text';
import If from '@buncha/components/conditional/If';
import React from 'react';
import {ScannerStyles} from './styles';

interface Props {
  expectedBarcodes: string[];
  allBarcodes: {
    [key: string]: boolean;
  };
}

const ExpectedBarcodes = (props: Props) => {
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');

  const {expectedBarcodes, allBarcodes} = props;

  return (
    <If condition={expectedBarcodes?.length}>
      <Box
        style={[
          ScannerStyles.barcodesContainer,
          {backgroundColor: theme?.background.white[100]},
        ]}>
        {expectedBarcodes?.map(barcode => (
          <HBox key={barcode}>
            <Checkbox
              _checked={{
                backgroundColor: theme?.icon.green[100],
                borderColor: theme?.icon.green[200],
              }}
              value=""
              isChecked={allBarcodes[barcode]}>
              <H6Text
                style={{
                  fontFamily: muliFont[700].normal,
                  color: theme?.text.blue[300],
                }}>
                {barcode}
              </H6Text>
            </Checkbox>
          </HBox>
        ))}
      </Box>
    </If>
  );
};

export default React.memo(ExpectedBarcodes);
